import DashboardComponent from "../components/DashboardComponent/DashboardComponent.js";
import ProductSynchronizationModal
  from "../components/modals/ProductSynchronizationModal/ProductSynchronizationModal.js";
  import AllCollectionWarningModal
  from "../components/modals/AllCollectionWarningModal/AllCollectionWarningModal.js";
import UpsellModal from "../components/modals/UpsellModal/UpsellModal.js";

const Dashboard = () => {
  return (
    <>
      <DashboardComponent />
      <ProductSynchronizationModal />
      <AllCollectionWarningModal />
      <UpsellModal />
    </>
  );
};

export default Dashboard;